import { ValidatorFn } from '@angular/forms';

import { ComponentTypesEnum } from '../enums';
import { BaseControlInterface } from '../interfaces';

export class BaseControl<ValueType = string | number | null> {
  public name: string;
  public value: ValueType | ValueType[] | null;
  public placeholder: string;
  public validators: ValidatorFn[];
  public componentType: ComponentTypesEnum;
  public errors: string[];
  public invalid: boolean;
  public disabled: boolean;
  public removable: boolean;
  public readonly: boolean;
  public floatingLabelNever: boolean;
  public hidden: boolean;
  public upperCaseValue: boolean;
  public hint: string;
  public outline: boolean;

  public more: { [key: string]: any };

  constructor(data: BaseControlInterface<ValueType>) {
    this.name = data.name;
    this.value = data.value;
    this.validators = data.validators;
    this.placeholder = data.placeholder ? data.placeholder : '';
    this.componentType = data.componentType;
    this.errors = data.errors ?? [];
    this.invalid = data.invalid ?? false;
    this.disabled = data.disabled ?? false;
    this.removable = data.removable ?? false;
    this.readonly = data.readonly ?? false;
    this.hidden = data.hidden ?? false;
    this.upperCaseValue = !data.upperCaseValue ? false : data.upperCaseValue;
    this.floatingLabelNever = data.floatingLabelNever ?? false;
    this.more = data.more ?? {};
    this.hint = data.hint ?? '';
    this.outline = typeof data.outline !== 'undefined' ? data.outline : false;
  }

  resetValue(): void {
    this.value = null;
  }

  resetValidators(): void {
    this.validators = [];
  }

  setValidators(validators: ValidatorFn[]): void {
    this.validators = validators;
  }

  extendValidators(validator: ValidatorFn): void {
    this.validators.push(validator);
  }

  setError(error: string): void {
    if (this.errors.indexOf(error) < 0) {
      this.errors.push(error);
    }
  }

  setErrors(errors: string[]): void {
    this.errors = errors;
  }

  resetErrors(): void {
    this.errors = [];
  }
}
